import React from "react";
import clsx from "clsx";
import "../../afs-walkthrough.css";
import WComponent from "../../../../../common/WComponent";
import AFSService from "../../../../../../services/AFSService";
import UtilityService from "../../../../../../services/UtilityService";

class TrialBalanceView extends WComponent {
	renderAccountRow = row => {
		const { hasTransactions, onDrillAccount } = this.props;

		const hasMovement = typeof row.movements === "number" && row.movements !== 0;
		const isDrillable = hasTransactions && hasMovement && !!onDrillAccount;
		const onDrill = isDrillable ? () => onDrillAccount(row.account) : undefined;

		const movementClass = clsx("afs-tb__td", hasMovement && "afs-tb__td--movement", isDrillable && "afs-tb__td--clickable");
		const hasAdjustment = typeof row.aje === "number" && row.aje !== 0;
		const ajeClass = clsx("afs-tb__td", hasAdjustment && "afs-tb__td--aje");

		const changeSign = row.changePercent > 0 ? "+" : "";
		const changeText = row.changePercent == null ? "–" : `${changeSign}${row.changePercent}%`;
		const changeClass = clsx("afs-tb__td afs-tb__td--change", row.changePercent > 0 && "afs-tb__td--change-up", row.changePercent < 0 && "afs-tb__td--change-down");

		return (
			<tr key={row.accountNumber || row.description}>
				<td className="afs-tb__td--left">{row.description}</td>
				<td className="afs-tb__td--acct-no">{row.accountNumber}</td>
				<td className="afs-tb__td">{row.opening == null ? "–" : UtilityService.formatAccountingAmount(row.opening)}</td>
				<td className={movementClass} onClick={onDrill}>{row.movements == null ? "–" : UtilityService.formatAccountingAmount(row.movements)}</td>
				<td className={ajeClass}>{row.aje == null ? "–" : UtilityService.formatAccountingAmount(row.aje)}</td>
				<td className="afs-tb__td afs-tb__td--closing">{UtilityService.formatAccountingAmount(row.closing)}</td>
				<td className="afs-tb__td afs-tb__td--prior">{UtilityService.formatAccountingAmount(row.prior)}</td>
				<td className={changeClass}>{changeText}</td>
			</tr>
		);
	};

	render() {
		const { balanceSheet, incomeStatement, transactions, adjustingEntries, currentYear, priorYear, gstHstAccount } = this.props;

		const sections = AFSService.buildTrialBalanceRows({ balanceSheet, incomeStatement, transactions, adjustingEntries, gstHstAccount });

		return (
			<div className="afs-tb__container">
				<table className="afs-tb__table">
					<thead>
						<tr>
							<th className="afs-tb__th--left">Account</th>
							<th className="afs-tb__th--left afs-tb__th--num">#</th>
							<th className="afs-tb__th">Opening ({priorYear})</th>
							<th className="afs-tb__th">Movements</th>
							<th className="afs-tb__th">AJE</th>
							<th className="afs-tb__th">Closing ({currentYear})</th>
							<th className="afs-tb__th afs-tb__th--prior">Prior year ({priorYear})</th>
							<th className="afs-tb__th afs-tb__th--change">Change</th>
						</tr>
					</thead>
					<tbody>
						{sections.map(section => (
							<React.Fragment key={section.name}>
								<tr><td colSpan={8} className="afs-tb__section-header">{section.name}</td></tr>
								{section.accounts.map(this.renderAccountRow)}
							</React.Fragment>
						))}
					</tbody>
				</table>
			</div>
		);
	}
}

export default TrialBalanceView;
